import { ClockCounterClockwiseIcon } from "@phosphor-icons/react/dist/csr/ClockCounterClockwise";
import { Button } from "@volca/ui/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { ToolbarSegment } from "./toolbar-segment";

interface ViewEditButtonProps {
  onViewEdit: () => void;
}

export const ViewEditButton = ({ onViewEdit }: ViewEditButtonProps) => (
  <ToolbarSegment>
    <TooltipProvider delay={200}>
      <Tooltip>
        <TooltipTrigger
          render={
            <Button
              variant="ghost"
              size="sm"
              className="text-sm font-normal text-subtle"
              onClick={onViewEdit}
              aria-label="View edit"
            />
          }
        >
          <ClockCounterClockwiseIcon data-icon="inline-start" />
          View edit
        </TooltipTrigger>
        <TooltipContent side="bottom">
          View this cell&apos;s edit history
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </ToolbarSegment>
);
